import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import PropTypes from 'prop-types';
import './style.scss';
const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', { color: [] }, { background: [] }],
    ['clean'],
  ],
};

const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'align',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'color',
  'background'];
// const [input, setInput] = useState('');
const RichTextEditor = ({ value, disabled, onChange, placeholder }) => (

  <ReactQuill
    readOnly={disabled}
    theme="snow"
    value={value}
    modules={modules}
    formats={formats}
    onChange={onChange}
    placeholder={placeholder || 'enter terms and conditions here..'}
    className="rich-text-editor__wrapper"
  />
);

RichTextEditor.propTypes = { value: PropTypes.any, onChange: PropTypes.func, disabled: PropTypes.bool };
export default RichTextEditor;
